/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react'
import {
  Item, Button, Grid, Loader, Header, Icon, Confirm, Image
} from 'semantic-ui-react'
import { HTTP, AppContext } from './../../providers'
import { Link } from 'react-router-dom'
import Thumbnail from '../../containers/Thumbnail'
import { getDataUrl, getClient } from '../../utils/functions'

const ManageRows = () => {
  const { beeAPI } = useContext(AppContext)
  const { store, dispatch } = beeAPI
  const { client } = store

  const [rows, setRows] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const [selected, setSelected] = useState(null)

  const getRows = React.useCallback(() => {
    const client = getClient()
    HTTP.get(`${client.demoAPI}/listRows`)
      .then(({ data }) => {
        const sortedRows = data.sort((a, b) => {
          a = new Date(a.date_created)
          b = new Date(b.date_created)
          return a > b ? -1 : a < b ? 1 : 0
        })
        setRows(sortedRows)
        saveRows(sortedRows)
      })
  }, [])

  const saveRows = React.useCallback((rows) => {
    dispatch({
      payload: {
        rows,
      }
    })
  }, [])

  const deleteRow = React.useCallback(() => {
    HTTP.delete(`${client.demoAPI}/deleteRow/${selected}`, { id: selected })
      .then(() => {
        getRows() // refresh page
      })
  }, [selected])

  useEffect(() => {
    getRows()
  }, [])

  const handleButtonClick = React.useCallback((id) => {
    setSelected(id)
    setIsOpen(true)
  }, [selected])

  const handleConfirm = React.useCallback(() => {
    deleteRow()
    setIsOpen(false)
  }, [selected])

  const handleCancel = React.useCallback(() => setIsOpen(false), [])

  return (
    (rows && rows.length > 0)
      ? (
        <>
          <Grid>
            <Grid.Row>
              <Header as='h2'>
                <Icon name='th list' />
                <Header.Content>
                  Manage saved rows
              <Header.Subheader>
                    Edit the rows you have saved for later use.
              </Header.Subheader>
                </Header.Content>
              </Header>
            </Grid.Row>
            <Grid.Row>
              {rows.map((row, i) => {
                const id = row.id
                const created = new Date(row.date_created)
                return (
                  <Grid.Column key={i} width={8}>
                    <Item.Group>
                      <Item key={id}>
                        {
                          (row.thumbnail)
                            ? (
                              <div style={{ height: '125px', width: '50%', marginRight: '15px' }}>
                                <Image
                                  src={getDataUrl(row.thumbnail)}
                                  style={{
                                    height: '100%',
                                    width: '100%',
                                    objectFit: 'scale-down',
                                    objectPosition: '0 0'
                                  }}
                                  bordered
                                />
                              </div>
                            )
                            : (<Thumbnail html={row.html} to={`/edit/${row.id}`} />)
                        }
                        <Item.Content>
                          <Item.Header>{row.name}</Item.Header>
                          <Item.Description>
                            <b>Category:</b> {row.category}<br />
                            <b>Created on:</b> {
                              created && created.toLocaleString('en-US', {
                                timeZone: 'UTC'
                              })
                            }
                          </Item.Description>
                          <Item.Extra>
                            <Button
                              floated='right'
                              onClick={() => handleButtonClick(row.id)}
                              negative
                            >
                              Delete
                        </Button>
                            <Button
                              floated='right'
                              as={Link}
                              to={`/edit/${row.id}`}
                            >
                              Edit
                        </Button>
                          </Item.Extra>
                        </Item.Content>
                      </Item>
                    </Item.Group>
                  </Grid.Column>
                )
              })}
            </Grid.Row>
          </Grid>
          <Confirm
            content='Are you sure you want to delete this row?'
            open={isOpen}
            onCancel={handleCancel}
            onConfirm={handleConfirm}
            size='small'
          />
        </>
      )
      : (<div style={{ padding: '5em 0' }}><Loader active inline='centered' style={{ padding: '3em 0' }}>Loading</Loader></div>)
  )
}

export default ManageRows
